module.exports = __webpack_public_path__ + "static/media/icon_community.d5f26837.svg";